import script from "./deliOnceImg4.vue?vue&type=script&setup=true&lang=js"
export * from "./deliOnceImg4.vue?vue&type=script&setup=true&lang=js"

import "./deliOnceImg4.vue?vue&type=style&index=0&id=5d97d727&lang=less"

const __exports__ = script;

export default __exports__